import React, { ReactNode } from 'react';

import { Can } from '@casl/react';

import { ability } from './ability';
import { parsePermission } from './parsePermission';

export interface ICanProps {
  permission: string;
  percent?: boolean;
  passThrough?: boolean;
  children: ReactNode | ((allowed: boolean) => ReactNode);
}

const can: React.FC<ICanProps> = ({ permission, children, ...rest }) => {
  if (permission) {
    const { action, subject } = parsePermission(permission);

    return (
      <Can I={action} a={subject} ability={ability} {...rest}>
        {children}
      </Can>
    );
  }

  return typeof children === 'function' ? children(true) : children;
};

export default can;
